import { FC } from 'react';
import { useHomeContext } from '#home/hooks';
import { BackgroundImageDefaultStyleDefault, BackgroundImageDefaultStyleRed } from '#home/components';

const BackgroundImageDefault: FC = () => {
  const { mainImageUrl } = useHomeContext();

  if (mainImageUrl) {
    return null;
  }

  return (
    <>
      <BackgroundImageDefaultStyleDefault />
      <BackgroundImageDefaultStyleRed />
    </>
  );
};

export { BackgroundImageDefault };
